import React from 'react';
import BookingCard from './BookingCard';

interface Booking {
  id: string;
  date_formatted: string;
  time_range: string;
  starts_at: string;
  status: string;
  client: {
    id: string;
    name: string;
    email: string;
    phone?: string;
    is_contact?: boolean;
  };
  service: {
    id: string;
    name: string;
    duration_min: number;
    price_cents: number;
    currency: string;
  };
  total_price_cents: number;
  currency: string;
}

interface BookingListProps {
  bookings: Booking[];
  onAction: (action: string, bookingId: string) => void;
}

const BookingList: React.FC<BookingListProps> = ({ bookings, onAction }) => {
  if (bookings.length === 0) {
    return (
      <div className="bg-gray-50 rounded-lg border border-gray-200 p-12 text-center">
        <svg
          className="mx-auto h-16 w-16 text-gray-300 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          No Bookings Found
        </h3>
        <p className="text-sm text-gray-600">
          No bookings match your current filters.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="mb-4">
        <p className="text-sm text-gray-600">
          {bookings.length} {bookings.length === 1 ? 'booking' : 'bookings'} found
        </p>
      </div>

      {bookings.map((booking) => (
        <BookingCard
          key={booking.id}
          booking={booking}
          onAction={onAction}
        />
      ))}
    </div>
  );
};

export default BookingList;
